// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"6b5c9940","221":"b5bb4ec0","536":"b9ade268","820":"cb776d62","890":"73164e06"}[chunkId] + ".chunk.css";
};